import { fetch, post } from '../../utility/fetch.js';
import { parseAndReplaceRules } from '../../static/workerSteps.js';

export default {
  state: {
    templates: [],
  },
  mutations: {
    setTemplates(state, templates) {
      state.templates = templates;
    },
  },
  actions: {
    async LOAD_TEMPLATES({ commit }) {
      const steps = await fetch('/AssetReviewApi/GetTemplateSteps');
      let templates = await fetch('/AssetReviewApi/GetWorkerTemplates');
      templates = templates.map((t) => {
        try {
          t.steps = parseAndReplaceRules(t.StepsJson, steps);
          t.stepsCount = t.steps.length;
        } catch (e) {
          console.error(`Unable to parse worker template (id:${t.id})`, e);
          t.steps = [];
        }
        return t;
      });
      commit('setTemplates', templates);
    },
    async ADD_TEMPLATE({ dispatch }, { name, trigger, templateSteps: steps }) {
      await post('/AssetReviewApi/SaveWorkerTemplate', {
        id: null,
        name,
        trigger,
        steps,
      });
      await dispatch('LOAD_TEMPLATES');
      return;
    },
    async UPDATE_TEMPLATE(
      { dispatch },
      { id, name, trigger, templateSteps: steps }
    ) {
      await post('/AssetReviewApi/SaveWorkerTemplate', {
        id,
        name,
        trigger,
        steps,
      });
      await dispatch('LOAD_TEMPLATES');
      return;
    },
    async DELETE_TEMPLATES({ dispatch }, templates) {
      for (let template of templates) {
        await fetch('/AssetReviewApi/DeleteWorkerTemplate', {
          id: template.id,
        });
      }
      await dispatch('LOAD_TEMPLATES');
      return;
    },
  },
};
